import { ArrowLeftRight, RotateCcw } from "lucide-react";
import { ZoneSelect } from "./ZoneSelect";
import { TimeInput } from "./TimeInput";
import { DIR_TO_IST, DIR_FROM_IST } from "../../lib/timeConverter";

const label = "block text-[11px] uppercase tracking-[0.18em] font-bold text-slate-500 mb-1.5";
const DIRS = [
    { id: DIR_TO_IST, text: "Local time → IST" },
    { id: DIR_FROM_IST, text: "IST → Local time" },
];

export function ConverterForm({ c, prefix }) {
    const toIst = c.dir === DIR_TO_IST;
    return (
        <div className="space-y-4" data-testid={`${prefix}-form`}>
            <div className="grid grid-cols-2 gap-1 p-1 bg-slate-100 rounded-xl" role="tablist" aria-label="Conversion direction">
                {DIRS.map((d) => (
                    <button key={d.id} type="button" role="tab" aria-selected={c.dir === d.id}
                        onClick={() => c.dir !== d.id && c.swap()} data-testid={`${prefix}-dir-${d.id}`}
                        className={`h-10 rounded-lg text-xs sm:text-sm font-bold transition-colors ${c.dir === d.id ? "bg-white text-[#1E3A8A] shadow-sm" : "text-slate-600 hover:text-[#0F172A]"}`}>
                        {d.text}
                    </button>
                ))}
            </div>

            <div>
                <span className={label}>{toIst ? "Parent's country, city or time zone" : "Destination country, city or time zone"}</span>
                <ZoneSelect value={c.zone} onChange={(v) => c.set({ zone: v })} date={c.date}
                    placeholder="Select or search country / time zone…" testId={`${prefix}-zone`} />
            </div>

            <div className="grid sm:grid-cols-2 md:grid-cols-1 xl:grid-cols-2 gap-4">
                <label className="block">
                    <span className={label}>{toIst ? "Parent's preferred date" : "Date in India (IST)"}</span>
                    <input type="date" value={c.date} min="1900-01-01" max="2100-12-31"
                        onChange={(e) => e.target.value && c.set({ date: e.target.value })}
                        data-testid={`${prefix}-date`}
                        className="w-full h-11 px-3 border border-slate-200 rounded-lg bg-white text-sm font-semibold text-[#0F172A] focus:border-[#1E3A8A] focus:ring-1 focus:ring-[#1E3A8A] outline-none" />
                </label>
                <div>
                    <span className={label}>{toIst ? "Parent's preferred local time" : "Time in India (IST)"}</span>
                    <TimeInput value={c.time} onChange={(t) => c.set({ time: t })} hour12={c.hour12} testId={`${prefix}-time`} />
                </div>
            </div>

            <div className="flex flex-wrap items-center gap-2 pt-1">
                <div className="inline-flex rounded-lg border border-slate-200 overflow-hidden" role="group" aria-label="Clock format">
                    {[[true, "12-hour"], [false, "24-hour"]].map(([v, t]) => (
                        <button key={t} type="button" onClick={() => c.setHour12(v)} aria-pressed={c.hour12 === v}
                            data-testid={`${prefix}-format-${v ? "12" : "24"}`}
                            className={`h-9 px-3 text-xs font-bold transition-colors ${c.hour12 === v ? "bg-[#0F172A] text-white" : "bg-white text-slate-600 hover:bg-slate-50"}`}>
                            {t}
                        </button>
                    ))}
                </div>
                <button type="button" onClick={c.swap} data-testid={`${prefix}-swap`}
                    className="h-9 inline-flex items-center gap-1.5 px-3 rounded-lg border border-slate-200 bg-white text-xs font-bold text-[#1E3A8A] hover:border-[#1E3A8A] transition-colors">
                    <ArrowLeftRight className="w-3.5 h-3.5" /> Swap direction
                </button>
                <button type="button" onClick={c.reset} data-testid={`${prefix}-reset`}
                    className="h-9 inline-flex items-center gap-1.5 px-3 rounded-lg border border-slate-200 bg-white text-xs font-bold text-slate-600 hover:border-slate-400 transition-colors">
                    <RotateCcw className="w-3.5 h-3.5" /> Reset
                </button>
            </div>
        </div>
    );
}
